module.exports = __webpack_public_path__ + "static/media/westinchennai06.881f2cf0.jpg";